import React from 'react';
import { Flex } from '@components';
import { Button, message, Spin, Tooltip } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NextButton from '@pages/SelfHelp/common/nextIndex';
import '../pay/index.css';
import './index.css';
import NHFetch from '@utils/NHFetch';
import { getLoginUser } from '@utils/NHCore';
import CommonTip from '../common';
import { mkbz as mkbzRouteMap } from '@pages/Assembly/siderMenu/menuObj';
import { handle } from '../pay/paydisc/index';
import Hint from '@pages/SelfHelp/common/hint';

/** 开发阶段缴费平台跳转地址，上线后替换为真实缴费页 */
const PAY_PLATFORM_URL = 'https://www.baidu.com';

function isPayFinished(sfbl) {
    return sfbl === true || sfbl === 'true';
}

function buildMenuStepUrl(menu) {
    if (!menu) {
        return { url: '', search: '' };
    }
    const hjdm = menu.HJDM;
    if (hjdm.indexOf('GD') === 0) {
        return { url: mkbzRouteMap[hjdm] || '', search: `pkid=${menu.PKID}` };
    }
    if (hjdm.indexOf('ZDY') === 0) {
        return { url: '/customLink', search: `pkid=${menu.PKID}&mkbz=${hjdm}&lx=${menu.LX}` };
    }
    if (hjdm.indexOf('DCWJ') === 0) {
        return { url: '/customizeExamination', search: `pkid=${menu.PKID}&mkbz=${hjdm}` };
    }
    return { url: '', search: '' };
}

export default class PaySzhtkj extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD008_14',
            hjmc: '',
            loading: false,
            nextUrl: '',
            search: '',
            operable: true,
            nonOperationalData: {},
            // payFinished: true,
            payFinished: false,
            /** 选宿舍后展示的通道文案（后端可在 queryPayInfoList 返回中扩展字段，如 tdmc、ssfsTd） */
            dormChannel: '',
            selectDormitoryCountdown: 0,
            jffaData: {},       //缴费方案信息
            jccsData: {},      //基础参数信息
            djcsData: {},     //缴费对接参数信息
            xsxxData: {},     //学生信息
            linkHandled: false, // 当前环节是否已办理
        };
        this.selectDormitoryTimer = null;
    }

    componentDidMount() {
        this.queryQztjAndYlhj();
        this.queryStudentInfo();
        this.queryPayPlan();
        this.checkIsZzbdHjLinked();
    }

    componentWillUnmount() {
        if (this.selectDormitoryTimer) {
            clearInterval(this.selectDormitoryTimer);
            this.selectDormitoryTimer = null;
        }
    }

    //查询学生信息
    queryStudentInfo = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (xsid) {
            NHFetch('/jfxt/queryStudentInfo', 'GET').then(res => {
                if (res && res.data) {
                    this.setState({
                        xsxxData: res.data
                    })
                } else {
                    message.error("获取学生信息失败");
                }
            })
        }
    }

    //根据环节代码获取对应的缴费方案数据
    queryPayPlan = () => {
        const { mkbz } = this.state;
        NHFetch('/jfxt/queryPayPlan', 'GET', { hjdm: mkbz }).then(res => {
            if (res && res.data) {
                this.setState({
                    jffaData: res.data['jffaVO'],
                    jccsData: res.data['jfdjJccsVO']
                }, () => {
                    this.queryQztjAndYlhj((operable) => { if (operable) { } });
                    this.queryPayParams()
                })
            } else {
                message.error("该环节未设置缴费方案")
            }
        })
    }

    //查询缴费对接参数
    queryPayParams = () => {
        const { djfsid } = this.state.jffaData;
        NHFetch('/jfxt/queryPayParams', 'GET', { djfsid: djfsid }).then(res => {
            if (res && res.data) {
                this.setState({
                    djcsData: res.data,
                })
            } else {
                message.error("获取缴费对接参数失败")
            }
        })
    }

    //跳转到收费平台
    toPayView = () => {
        const { djcsData, xsxxData, jccsData, jffaData } = this.state;
        const { djfsid } = this.state.jffaData;
        let csxx = Object.assign(jccsData, djcsData);
        this.setButtonLoading(true);
        handle(djfsid, "", csxx, xsxxData, "", "", "", "", "", (buttonLoading) => { this.setButtonLoading(buttonLoading) });
    };

    setButtonLoading = (buttonLoading) => {
        this.setState({
            buttonLoading
        })
        setTimeout(() => {
            this.setState({
                buttonLoading: false
            });
        }, 10000);
    }

    getQueryString = name => {
        return (
            decodeURIComponent(
                (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(
                    /\+/g,
                    '%20'
                )
            ) || null
        );
    };

    queryQztjAndYlhj = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        const zzbdhjid = this.getQueryString('pkid');
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid, zzbdhjid }).then(res => {
            if (res && res.data) {
                const kfsj = res.data.kfsj;
                const ylhj = res.data.ylhj;
                const qzhj = res.data.qzhj;
                const nohj = res.data.nohj;
                this.setState({ nonOperationalData: res.data });
                if (kfsj && kfsj.YXSJ != '1') {
                    this.setState({ operable: false });
                } else if (ylhj && ylhj.length > 0) {
                    this.setState({ operable: false });
                } else if (qzhj && qzhj.length > 0) {
                    this.setState({ operable: false });
                } else if (nohj) {
                    this.setState({ operable: false });
                } else {
                    this.queryPayInfoList();
                }
            }
        });
    };

    /**
     * 学费缴纳查询：/jfxt/queryPayInfoList?hjdm=GD008_14
     * sfbl 为 true 表示缴费已完成
     */
    queryPayInfoList = (callback) => {
        const { mkbz, payFinished } = this.state;
        let finished = payFinished;
        this.setState({ loading: true });
        NHFetch('/jfxt/queryPayInfoList', 'GET', { hjdm: mkbz })
            .then(res => {
                this.setState({ loading: false });
                if (res && res.data) { 
                    finished = isPayFinished(res.data.sfbl); 
                    if (finished) {
                        this.checkIsZzbdHjLinked();
                    }
                    this.setState({
                        payFinished: finished,
                    });
                } else { 
                    message.info('查询不到学生的缴费信息，请联系管理员处理');
                }
                if (typeof callback === 'function') {
                    callback(finished);
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    checkIsZzbdHjLinked = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');

        NHFetch('/zzbdCommon/checkIsZzbdHjLinked', 'GET', { xsid, zzbdhjid }).then(res => {
            if (res && res.code === 200) {
                this.setState({ linkHandled: res.data });
            } else {
                message.error('查询环节办理状态失败，请稍后再试');
            }
        });
    };

    commonSaveLinkTransactionStatus = () => {
        const xsid = getLoginUser() ? getLoginUser().userId : '';
        const zzbdhjid = this.getQueryString('pkid');
        const params = { xsid, zzbdhjid };
        NHFetch('/zzbdCommon/commonSaveLinkTransactionStatus', 'POST', params).then(res => {
            if (res) {
                if (res.data === 1) {
                    this.setState({ linkHandled: true });
                    this.reloadMenu();
                }
            } else {
                message.error('自动办理缴费环节失败，请稍后重试！');
            }
        });
    };

    reloadMenu = () => {
        if (this.refs.siderMenu && this.refs.siderMenu.reloadMenuList) {
            this.refs.siderMenu.reloadMenuList();
        }
    };

    setMenuList = menuList => {
        const bz = this.state.mkbz;
        let currentIndex = -1;
        menuList.forEach((elem, index) => {
            if (elem.HJDM == bz) {
                this.setState({ hjmc: elem.HJMC });
                currentIndex = index;
            }
        });

        const nextMenu = currentIndex >= 0 && currentIndex < menuList.length - 1 ? menuList[currentIndex + 1] : null;
        const nextStep = buildMenuStepUrl(nextMenu);
        if (nextMenu) {
            this.setState({
                nextUrl: nextStep.url,
                search: nextStep.search,
            });
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            });
        }
    };

    openPayPlatform = () => {
       this.toPayView();
    };

    /** 选宿舍：依赖缴费完成（sfbl）；重新拉取接口并分配/刷新宿舍通道展示 */
    onSelectDormitory = () => {
        const { payFinished, selectDormitoryCountdown } = this.state;
        if (!payFinished) {
            message.warning('请先在缴费平台完成学费和住宿费缴纳，再回到本页刷新状态。');
            return;
        }
        if (selectDormitoryCountdown > 0) {
            return;
        }
        this.setState({ selectDormitoryCountdown: 40 });
        this.selectDormitoryTimer = setInterval(() => {
            this.setState(prevState => {
                if (prevState.selectDormitoryCountdown <= 1) {
                    clearInterval(this.selectDormitoryTimer);
                    this.selectDormitoryTimer = null;
                    return { selectDormitoryCountdown: 0 };
                }
                return { selectDormitoryCountdown: prevState.selectDormitoryCountdown - 1 };
            });
        }, 1000);
        this.queryPayInfoList((finished) => {
            const xsid = getLoginUser() ? String(getLoginUser().userId) : '';
            const fallbackTd = xsid && xsid.length % 2 === 0 ? '通道1' : '通道2';
            if (finished) {
                this.commonSaveLinkTransactionStatus();
                this.setState({
                    dormChannel: fallbackTd,
                });
                message.success('已刷新宿舍分配通道，请按通道提示继续办理。');
            } else {
                this.setState({
                    selectDormitoryFailTip: '请稍后重新点击选宿舍',
                });
                message.warning('当前查询缴费仍未完成，请完成缴费后再选宿舍。');
            }
        })
    };

    render() {
        const { loading, payFinished, dormChannel, nextUrl, search, selectDormitoryCountdown, selectDormitoryFailTip, linkHandled } = this.state;
        /** 本页「下一步」显隐：有下一环节地址且已缴费、已选宿舍（有通道）后才展示 */
        const showNextButton = !!nextUrl && payFinished && !!dormChannel;

        return (
            <div className="page_pay">
                {this.state.operable ? (
                    <Flex className="w1180 mt-20" align="start">
                        <SiderMenu
                            ref="siderMenu"
                            setMenuList={this.setMenuList}
                            title="自助报到"
                            mkbz={this.state.mkbz}
                            menuType="自助报到"
                        />
                        <Flex.Item className="page_con_r">
                            <Breadcrumb
                                noLine
                                list={[
                                    { name: '首页', url: '/index' },
                                    { name: '自助报到', url: '/register' },
                                    { name: this.state.hjmc },
                                ]}
                            />
                            <div className="box">
                                <Hint />
                                <TitleTop title={this.state.hjmc || '缴费环节'} extra={false} />
                                <Spin spinning={loading}>
                                    <div className="p-sw mt-20 paySzhtkj-wrap">
                                        <div className="paySzhtkj-row" style={{marginBottom: '25px'}}>
                                            <Button type="primary" disabled={linkHandled} onClick={this.openPayPlatform}>
                                                缴费
                                            </Button>
                                            <div className="paySzhtkj-hint" style={{margin: '5px'}}>
                                                点击跳转缴费平台，完成学费和住宿费的缴纳，完成后，请退出缴费页面，回到当前页面。
                                            </div>
                                        </div>
                                        <div className="paySzhtkj-row" style={{marginBottom: '25px'}}>
                                            <Button
                                                type="primary"
                                                disabled={linkHandled || !payFinished || selectDormitoryCountdown > 0}
                                                onClick={this.onSelectDormitory}
                                            >
                                                {selectDormitoryCountdown > 0 ? `选宿舍（${selectDormitoryCountdown}s）` : '选宿舍'}
                                            </Button>
                                            <div className="paySzhtkj-hint" style={{margin: '5px'}}>
                                                请在缴费页面完成缴费后，点击选宿舍，系统自动分配选宿舍通道。
                                            </div>
                                        </div>
                                        <div className="paySzhtkj-row" style={{marginBottom: '25px'}}>
                                            <Button type="default" disabled={!dormChannel}>
                                                宿舍通道
                                            </Button>
                                            <div className="paySzhtkj-hint" style={{margin: '5px'}}>
                                                {dormChannel ? `当前通道：${dormChannel}` : selectDormitoryFailTip ? `${selectDormitoryFailTip}` : null}
                                            </div>
                                        </div>
                                        <div className="text-center mt-50">
                                            <div className="text-center mt-50">
                                                <NextButton nextUrl={nextUrl} search={search} />
                                                <div className="paySzhtkj-hint" style={{margin: '5px'}}>
                                                    若下一环节提示缴费环节未完成，请重新进入缴费环节点击「选宿舍」，刷新宿舍分配通道。
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Spin>
                            </div>
                        </Flex.Item>
                    </Flex>
                ) : (
                    <CommonTip
                        hjmc={this.state.hjmc || '学费缴纳'}
                        key="GD008_14"
                        mkbz="GD008_14"
                        nonOperationalData={this.state.nonOperationalData}
                    />
                )}
            </div>
        );
    }
}
